<template>
  <div class="relative">
    <TButton
      :inverse="inverse"
      @click="open = !open"
      class="w-8 h-8"
      tooltip="Edit HTML"
    >
      <template #icon>
        <svg
          width="16"
          height="16"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.9375 3.37499L13.9375 33.375C13.75 33.875 13.1875 34.125 12.625 34C12.125 33.8125 11.875 33.25 12 32.6875L22 2.68749C22.1875 2.18749 22.75 1.93749 23.3125 2.06249C23.8125 2.24999 24.0625 2.81249 23.9375 3.37499ZM10.625 10.75L2.5 18L10.625 25.25C11.0625 25.625 11.0625 26.25 10.6875 26.6875C10.375 27.125 9.6875 27.125 9.3125 26.75L0.3125 18.75C0.0625 18.5625 0 18.3125 0 18C0 17.75 0.0625 17.5 0.3125 17.25L9.3125 9.24999C9.6875 8.93749 10.375 8.93749 10.6875 9.37499C11.0625 9.74999 11.0625 10.4375 10.625 10.75ZM26.625 9.24999L35.625 17.25C35.875 17.5 36 17.75 36 18C36 18.3125 35.875 18.5625 35.625 18.75L26.625 26.75C26.25 27.125 25.5625 27.125 25.25 26.6875C24.875 26.25 24.875 25.625 25.3125 25.25L33.4375 18L25.3125 10.75C24.875 10.4375 24.875 9.74999 25.25 9.37499C25.5625 8.93749 26.25 8.93749 26.625 9.24999Z"
            fill="currentColor"
          />
        </svg>
      </template>
    </TButton>
    <htmlEditor
      v-if="open"
      :tiptap-editor="editor"
      :merge-tags="mergeTags"
      :inverse="inverse"
      @close="open = false"
      @set-content="(content: string) => editor.commands.setContent(content)"
    />
  </div>
</template>
<script setup lang="ts">
import htmlEditor from "../../htmlEditor/htmlEditor.vue";
import IEditorConfig from "../../../../types/IEditorConfig";
import { TButton } from "@topol/twig-ui";
import data from "emoji-mart-vue-fast/data/all.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast/src";
import { Editor } from "@tiptap/core";
import { ref } from "vue";

const props = defineProps<{
  editor: Editor;
  mergeTags?: IEditorConfig["mergeTags"];
  inverse?: boolean;
}>();

const open = ref(false);

const emojiIndex = new EmojiIndex(data);

function select(emoji: { native: string }) {
  props.editor.chain().focus().insertContent(emoji.native).run();
  open.value = false;
}
</script>
